const allChecked = (s) => {
  const checks = s.root.consentChecks || {}
  return checks.procedure && checks.risks && checks.alternatives && checks.outcomes && checks.aftercare
}

export const ESignature = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  SignatureTitle: {
    tag: 'h4',
    text: '{{ eSignatureTitle | polyglot }}',
    fontSize: 'Z',
    fontWeight: '700',
    color: 'inkText'
  },

  DisabledNotice: {
    if: (el, s) => !allChecked(s),
    text: '{{ consentCheckAllFirst | polyglot }}',
    fontSize: 'Y',
    color: 'amber',
    fontWeight: '500'
  },

  CanvasWrap: {
    position: 'relative',
    width: '100%',
    height: '200px',
    round: 'Y',
    border: (el, s) => allChecked(s) ? '2px solid teal' : '2px solid inkBorder',
    background: 'white',
    overflow: 'hidden',
    opacity: (el, s) => allChecked(s) ? '1' : '0.4',
    pointerEvents: (el, s) => allChecked(s) ? 'auto' : 'none',
    transition: 'opacity .2s, border-color .2s',

    SignCanvas: {
      tag: 'canvas',
      width: '100%',
      height: '100%',
      style: { display: 'block' },
      onRender: (el, s) => {
        if (el.__initialized) return
        el.__initialized = true
        const canvas = el.node
        const resize = () => {
          const rect = canvas.parentElement.getBoundingClientRect()
          canvas.width = rect.width
          canvas.height = rect.height
        }
        resize()
        const ctx = canvas.getContext('2d')
        ctx.lineWidth = 2
        ctx.lineCap = 'round'
        ctx.strokeStyle = '#1a1a2e'
        let drawing = false

        const getPos = (e) => {
          const rect = canvas.getBoundingClientRect()
          const touch = e.touches ? e.touches[0] : e
          return { x: touch.clientX - rect.left, y: touch.clientY - rect.top }
        }

        const start = (e) => {
          e.preventDefault()
          drawing = true
          const p = getPos(e)
          ctx.beginPath()
          ctx.moveTo(p.x, p.y)
        }
        const move = (e) => {
          if (!drawing) return
          e.preventDefault()
          const p = getPos(e)
          ctx.lineTo(p.x, p.y)
          ctx.stroke()
        }
        const stop = () => { drawing = false }

        canvas.addEventListener('mousedown', start)
        canvas.addEventListener('mousemove', move)
        canvas.addEventListener('mouseup', stop)
        canvas.addEventListener('mouseleave', stop)
        canvas.addEventListener('touchstart', start, { passive: false })
        canvas.addEventListener('touchmove', move, { passive: false })
        canvas.addEventListener('touchend', stop)

        el.__ctx = ctx
        el.__canvas = canvas
        el.__resize = resize
        window.addEventListener('resize', resize)
      }
    }
  },

  Actions: {
    flow: 'x',
    gap: 'Y',
    marginTop: 'Y',

    ClearBtn: {
      extends: 'Button',
      text: '{{ clearSignature | polyglot }}',
      fontSize: 'Y',
      padding: 'Y Z',
      round: 'Z',
      background: 'inkSurface',
      color: 'inkText',
      fontWeight: '600',
      cursor: 'pointer',
      opacity: (el, s) => allChecked(s) ? '1' : '0.4',
      pointerEvents: (el, s) => allChecked(s) ? 'auto' : 'none',
      onClick: (e, el, s) => {
        const canvasEl = el.parent.parent.CanvasWrap.SignCanvas
        if (canvasEl.__canvas && canvasEl.__ctx) {
          canvasEl.__resize()
          canvasEl.__ctx.lineWidth = 2
          canvasEl.__ctx.lineCap = 'round'
          canvasEl.__ctx.strokeStyle = '#1a1a2e'
        }
        s.root.update({ signatureData: null, signatureCaptured: false })
      }
    },

    ConfirmBtn: {
      extends: 'Button',
      text: '{{ confirmSignature | polyglot }}',
      fontSize: 'Y',
      padding: 'Y Z',
      round: 'Z',
      background: (el, s) => allChecked(s) && !s.root.signatureCaptured ? 'teal' : 'inkSurface',
      color: (el, s) => allChecked(s) && !s.root.signatureCaptured ? 'white' : 'inkMuted',
      fontWeight: '600',
      cursor: (el, s) => allChecked(s) && !s.root.signatureCaptured ? 'pointer' : 'default',
      opacity: (el, s) => allChecked(s) && !s.root.signatureCaptured ? '1' : '0.4',
      pointerEvents: (el, s) => allChecked(s) && !s.root.signatureCaptured ? 'auto' : 'none',
      onClick: (e, el, s) => {
        const canvasEl = el.parent.parent.CanvasWrap.SignCanvas
        if (canvasEl.__canvas) {
          const data = canvasEl.__canvas.toDataURL('image/png')
          s.root.update({
            signatureData: data,
            signatureCaptured: true,
            signatureTimestamp: new Date().toLocaleString()
          })
        }
      }
    }
  },

  SignedConfirmation: {
    if: (el, s) => !!s.root.signatureCaptured,
    flow: 'x',
    align: 'center flex-start',
    gap: 'Y',
    padding: 'Y Z',
    round: 'Y',
    background: 'green.15',
    SignedIcon: { tag: 'span', text: '\u2713', color: 'green', fontWeight: '700', fontSize: 'Z' },
    SignedText: {
      text: (el, s) => `{{ signatureCapturedAt | polyglot }} ${s.root.signatureTimestamp || ''}`,
      fontSize: 'Y',
      color: 'green',
      fontWeight: '500'
    }
  }
}
